export default "__VITE_ASSET__DwmNc2UA__"